'use strict';

import Cookies from 'js-cookie';

const cookie_name = 'itg_forms';

const site_referrer = 'referring_website';
const site_arrival = 'arrival_url';
const user_lastvisit = 'lastvisit';
const user_lastname = 'lastname';
const user_firstname = 'firstname';
const user_birthdate = 'birthdate';
const user_phone = 'phone';
const user_zipcode = 'zipcode';
const user_email = 'email';
const user_speciality = 'speciality';
const user_simulator_salary = 'simulator_salary';
const user_simulator_billing = 'simulator_billing';
const user_become_consultant = 'become_consultant';
const user_entreprise = 'entreprise';
const user_fonction = 'fonction';
const user_simulator_visited = 'simulator_visited';
const user_banner_webinar_closed = 'banner_webinar_closed';

const cookies_keys = [
    site_referrer,
    site_arrival,
    user_lastvisit,
    user_lastname,
    user_firstname,
    user_birthdate,
    user_phone,
    user_zipcode,
    user_email,
    user_speciality,
    user_simulator_salary,
    user_simulator_billing,
    user_become_consultant,
    user_entreprise,
    user_fonction,
    user_simulator_visited,
    user_banner_webinar_closed
];

class CookieManager {
    constructor () {
        // console.log('cookieManager constructor');
        // console.log('referrer', document.referrer);
        // console.log('cookie referrer', this.getCookieValue(this.site_referrer));
        // console.log('arrival', this.getCookieValue(this.site_arrival));
        // console.log('cookie arrival', this.getCookieValue(this.site_arrival));

        // Set on instanciation since CookieManager is a singleton
        if (this.getCookieValue(this.site_referrer) === '' || this.getCookieValue(this.site_referrer) === undefined) {
            let referrer = (document.referrer === '') ? 'direct' : document.referrer;
            this.store({[this.site_referrer]: referrer});
        }

        if (this.getCookieValue(this.site_arrival) === '' || this.getCookieValue(this.site_arrival) === undefined) {
            this.store({[this.site_arrival]: window.location.href});
        }
    }

    get site_referrer () { return site_referrer }
    get site_arrival () { return site_arrival }

    get user_lastvisit () { return user_lastvisit }
    get user_lastname () { return user_lastname }
    get user_firstname () { return user_firstname }
    get user_birthdate () { return user_birthdate }
    get user_phone () { return user_phone }
    get user_zipcode () { return user_zipcode }
    get user_email () { return user_email }
    get user_speciality () { return user_speciality }
    get user_simulator_salary () { return user_simulator_salary }
    get user_simulator_billing () { return user_simulator_billing }
    get user_become_consultant () { return user_become_consultant }
    get user_entreprise () { return user_entreprise }
    get user_fonction () { return user_fonction }
    get user_simulator_visited () { return user_simulator_visited }
    get user_banner_webinar_closed () { return user_banner_webinar_closed }

    get cookieValues () {
        if (Cookies.get(cookie_name) === undefined) return false;
        return JSON.parse(Cookies.get(cookie_name));
    }

    checkCookieKey (key) {
        if (!cookies_keys.includes(key)) throw new Error('Cookie key ' + key + ' doesn\'t exist');
        return true;
    }

    store (o) {
        // console.log(o, Object.keys(o));
        let values = this.cookieValues || {};
        Object.keys(o).map(key => {
            this.checkCookieKey(key);
            values[key] = o[key];
        });
        // console.log(values);
        Cookies.set(cookie_name, values);
    }

    getCookieValue (key) {
        // console.log(key, cookies_keys.includes(key), Cookies.get(cookie_name));
        if (Cookies.get(cookie_name) === undefined) return '';
        this.checkCookieKey(key);
        return this.cookieValues[key];
    }
}

export let cookieManager = new CookieManager();



// WEBPACK FOOTER //
// ./front/js/services/CookieManager.js